module.exports = __webpack_public_path__ + "img/login-v6.5b5149c3.svg";